import { EOtherIncomeType, getEOtherIncomeTypeSelectableList } from '@if/core/types'
import { ControlledNumberField, ControlledSelect, ControlledTextField, useTranslatedOptionEnum } from '@if/mui'
import { Stack } from '@mui/material'
import { ApplicantOtherIncome } from '@src/types/CreditApplicationSchema'
import { Control, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

interface Props {
  control: Control<ApplicantOtherIncome>
}

/** The fields shared by the add/edit other-income dialog (see useFormDialog). */
const OtherIncomeDialogFields = ({ control }: Props) => {
  const { t } = useTranslation()
  const typeId = Number(useWatch({ control, name: 'typeId' }))
  const otherIncomeTypeOptions = useTranslatedOptionEnum(
    'EOtherIncomeType',
    getEOtherIncomeTypeSelectableList(),
    'enum',
  )

  return (
    <Stack spacing={2} sx={{ mt: 1 }}>
      <ControlledSelect
        name="typeId"
        control={control}
        label={t('editCreditApplication.income.other.typeId')}
        options={otherIncomeTypeOptions}
        disableEmptyOption
      />
      {typeId === (EOtherIncomeType.Other as number) && (
        <ControlledTextField
          name="description"
          control={control}
          label={t('editCreditApplication.income.other.description')}
          slotProps={{ htmlInput: { maxLength: 50 } }}
        />
      )}
      <ControlledNumberField
        name="annualAmount"
        control={control}
        label={t('editCreditApplication.income.other.annualAmount')}
        disableDecimals
        isMoney
      />
    </Stack>
  )
}

export default OtherIncomeDialogFields
